import {
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  numberedEnv,
  localizeKey,
  sentryDSNKey,
  isNumberedEnv,
  OAUTH_PROVIDERS_EU,
  COOKIE_POLICY_URL,
  DATA_PROCESSING_AGREEMENT_URL,
  PRIVACY_POLICY_URL,
  TERMS_OF_SERVICE_URL,
} from "@src/runtime-config-base";
import { RuntimeConfig } from "@src/runtime-config-types";

export const runtimeConfig: RuntimeConfig = {
  environment: "staging",
  appRegion: "eu",
  appEnv: "eu-staging",
  urls: {
    apiBaseUrl: "https://core.api.staging.holobuilder.eu",
    projectApiUrl: "https://v2.project.api.staging.holobuilder.eu",
    viewerUrl:
      numberedEnv === "dev1"
        ? "https://dev1.viewer.staging.holobuilder.eu"
        : "https://viewer.staging.holobuilder.eu",
    webEditorUrl: "https://app.staging.holobuilder.eu/app",
    apiBaseComUrl: "https://core.api.staging.holobuilder.com",
    apiBaseEuUrl: "https://core.api.staging.holobuilder.eu",
    sphereDashboardUrl:
      numberedEnv === "dev1"
        ? "https://dev1.sphere.staging.holobuilder.eu"
        : "https://sphere.staging.holobuilder.eu",
    dashboard20ComUrl:
      numberedEnv === "dev1"
        ? "https://dev1.sphere.staging.holobuilder.com"
        : "https://sphere.staging.holobuilder.com",
    dashboard20EuUrl:
      numberedEnv === "dev1"
        ? "https://dev1.sphere.staging.holobuilder.eu"
        : "https://sphere.staging.holobuilder.eu",
    sphereEntryPageComUrl:
      numberedEnv === "dev1"
        ? "https://dev1.entry.staging.holobuilder.com"
        : "https://entry.staging.holobuilder.com",
    sphereEntryPageEuUrl:
      numberedEnv === "dev1"
        ? "https://dev1.entry.staging.holobuilder.eu"
        : "https://entry.staging.holobuilder.eu",
    sphereEntryPageApi: "https://entry.staging.holobuilder.eu/api",
    termsOfServiceUrl: TERMS_OF_SERVICE_URL,
    privacyPolicyUrl: PRIVACY_POLICY_URL,
    dataProcessingAgreementUrl: DATA_PROCESSING_AGREEMENT_URL,
    cookiePolicyUrl: COOKIE_POLICY_URL,
  },
  features: {
    localizeKey,
    sentryDSNKey,
  },
  oauth: {
    providers: OAUTH_PROVIDERS_EU,
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support-eu+staging@holobuilder.com",
  isNumberedEnv,
  numberedEnv,
};
